module.exports = __webpack_public_path__ + "static/media/default-profile.d32811df.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/faces/default-profile.jpg
// module id = 357
// module chunks = 0